/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import MEITotalElectricSalesPage from 'src/pages/ReportsPages/ReportsBoard/MEIpages/MEITotalElectricSalesPage'
import boardReportsService from 'src/services/boardReportsService'

const MEITotalElectricSalesContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [tableTotalIndustry, setTableTotalIndustry] = useState([])
  const [tableTotalIndustryMonth, setTableTotalIndustryMonth] = useState([])
  const [gATotalIndustry, setATotalIndustry] = useState([])
  const [gBTotalIndustry, setBTotalIndustry] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadImports = async () => {
    const [tableTotalIndustry, tableTotalIndustryMonth, gATotalIndustry, gBTotalIndustry] = await Promise.all([
      boardReportsService.getTotalSalesMEI('5', selectedDate.getFullYear()),
      boardReportsService.getTotalSalesMEI('6', selectedDate.getFullYear()),
      boardReportsService.graphicsTotalSalesMEI('3a', selectedDate.getFullYear()),
      boardReportsService.graphicsTotalSalesMEI('3b', selectedDate.getFullYear()),
    ])
    setTableTotalIndustry(tableTotalIndustry)
    setTableTotalIndustryMonth(tableTotalIndustryMonth)
    setATotalIndustry(gATotalIndustry)
    setBTotalIndustry(gBTotalIndustry)
  }

  useEffect(() => {
    reloadImports()
  }, [])

  return (
    <MEITotalElectricSalesPage
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      tableTotalIndustry={tableTotalIndustry}
      gATotalIndustry={gATotalIndustry}
      gBTotalIndustry={gBTotalIndustry}
      tableTotalIndustryMonth={tableTotalIndustryMonth}
    />
  )
}

export default MEITotalElectricSalesContainer
